import { z } from 'zod'

// uiレイヤでこれを呼ぶと実行時エラーになる？循環参照している？
export const nodePropertyNameSchema = z.object({
  nodeName: z.string(),
  modelName: z.string(),
  propertyName: z.string(),
})
export type NodePropertyName = z.infer<typeof nodePropertyNameSchema>
